<template>
  <div class="card border-0 ms-0 col-md-10 col-lg-10 col-sm-12">
      <div class="card-body">
        <p>
          By default, all email addresses receive mails from the test server. You can restrict this using the box below.
        </p>
        <ul>
          <li>Please specify the e-mail addresses that <b>should</b> receive e-mails from the test server.</li>
          <li>Use one new line for each e-mail address.</li>
          <li>Addresses not specified below will <b>not</b> receive e-mails from the test server.</li>
        </ul>
      <p>
        <b>PLEASE NOTE: </b>This setting must be made on the test server, not on the live server
      </p>
      <div class="mb-3">
        <label class="form-label">E-mail addresses</label>
        <textarea 
          v-model="addresses"
          rows="10"
          class="form-control"
        ></textarea>
      </div>
      <div class="form-group col-12 mt-4">
        <button 
          @click.prevent="data_save" 
          class="btn btn-primary mt-10"
        >
          Save Mail Addresses
        </button>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
const syspref_key = 'test_emails';

export default {
  created() {
    this.data_get()
  },
  data() {
    return {
      addresses: '',
    }
  },
  methods: {
    data_get() {
      this.addresses = '';
      this.$store.dispatch('syspref_fetch', { key: syspref_key })
      .then((res) => {
        if (res.data && res.data.value && res.data.value !== "") {
          try {
            let dataarray = JSON.parse(res.data.value)
            this.addresses = dataarray.join('\n');
          } catch (e) {
            console.error('Error parsing test email addresses:', e);
            this.addresses = '';
          }
        }
      })     
    },
    data_save() {
      const newaddresses = this.addresses.split("\n").filter( f => f != '');
      this.$store.dispatch('syspref_save', { key: syspref_key,value: JSON.stringify(newaddresses) })
      .then( () => this.data_get());
    },
  }
}
</script>
<style>
</style>
